import { REDIRECT_AREA_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useRedirectAreaListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${REDIRECT_AREA_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
